import React from 'react';
import ComCourtApiSettings from './comcourt-api-settings';
import LawbaseApiSettings from './lawbase-api-settings';

export default function ApiSettings() {
  return (
    <React.Fragment>
      <ComCourtApiSettings></ComCourtApiSettings>
      {/* <LawbaseApiSettings></LawbaseApiSettings> */}
    </React.Fragment>
  );
}
